import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'askemo-content-loader',
    imports: [MatProgressSpinnerModule],
    templateUrl: './content-loader.component.html',
    styleUrl: './content-loader.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentLoaderComponent {
    public readonly isOverlay = input<boolean>(false);
    public readonly hasBackdrop = input<boolean>(false);
    @HostBinding('class.content-loader-backdrop')
    public config = {
        strokeWidth: 4,
        diameter: 50,
    };
}
